<template>
    <CustomSelect
        name="nationality"
        :value="nationality"
        idField="id"
        displayField="name"
        :options="nationalities"
        :errorMessage="errors.nationality"
        label="pick nationality"
        @input="$emit('update:nationality', $event)"
        @valueChanged="$listeners.valueChanged"
        @blur="$listeners.blur"
    />
</template>

<script>
    import nationalities from '@countryModules/authentication/nationalities';

    export default {
        props: {
            nationality: {
                type: String,
                required: false,
            },
            errors: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                nationalities: nationalities.map((e) => (
                    {
                        id: e,
                        name: e
                    }
                ))
            };
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/authentication/components/register/Nationality.vue